var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st4{fill:none;}\n\t.st5{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M365.9,139.1c-2.4-2.4-6.1-2.9-9-1.4l0-0.1l-135.4,65.8l0,0.1c-5.1,2.7-10,6.2-14.3,10.6 c-23.1,23.1-23.1,60.6,0,83.7c23.1,23.1,60.5,23.1,83.6,0c5.1-5.1,9-10.8,11.8-16.9l64.6-132.8l0,0 C368.7,145.2,368.3,141.5,365.9,139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M254.4,31.9c-121.6,0-220.2,98.6-220.2,220.2c0,43.6,12.7,84.2,34.5,118.4l-42.5,70.6l0.1,0.1 c-2.6,4-2.5,9.3,0.8,13.2c3,3.5,7.7,4.8,11.8,3.5l0,0l0,0l81.5-30.9c37.1,28.4,83.5,45.4,133.8,45.3 c121.6,0,220.2-98.6,220.2-220.2S376,31.9,254.4,31.9z M367.2,148.1l-64.6,132.8c-2.8,6.1-6.8,11.8-11.8,16.9 c-23.1,23.1-60.5,23.1-83.6,0c-23.1-23.1-23.1-60.6,0-83.7c4.3-4.3,9.2-7.9,14.3-10.6l0-0.1l135.4-65.8l0,0.1 c2.9-1.5,6.5-1.1,9,1.4C368.3,141.5,368.7,145.2,367.2,148.1L367.2,148.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/Logo-White.98c525416d3bc4fbed380a639c4ac4ac.svg";
export { ForwardRef as ReactComponent };